<template>
	<DjBox>
		<BaseCloudImage
			class="max-w-full rounded-t-2xl overflow-hidden"
			:class="title != '' ? '' : 'rounded-b-2xl'"
			:public-id="photoId"
			:alt="photoAlt || title"
			:postfix="postfix"
			:transformation="[{ width: 440, crop: 'scale' }]"
		/>
		<h3 v-if="title != ''" class="p-3 md:pt-7 md:pb-6 md:px-6 text-lg md:text-xl font-medium">{{ title }}</h3>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DjBox from "./DjBox.vue";
import BaseCloudImage from "../BaseCloudImage.vue";

export default defineComponent({
	name: "DjBoxPhoto",
	components: {
		BaseCloudImage,
		DjBox,
	},
	props: {
		title: {
			type: String,
			default: "",
			required: true,
		},
		photoAlt: {
			type: String,
			default: "",
			required: false,
		},
		photoId: {
			type: String,
			default: "",
			required: true,
		},
		postfix: {
			type: String,
			default: ".jpg",
		},
	},
});
</script>
